module.exports = __webpack_public_path__ + "img/bgtop.d8778e4d.jpg";